import { render, staticRenderFns } from "./DashboardSection.vue?vue&type=template&id=42943f32&scoped=true"
import script from "./DashboardSection.vue?vue&type=script&lang=js"
export * from "./DashboardSection.vue?vue&type=script&lang=js"
import style0 from "./DashboardSection.vue?vue&type=style&index=0&id=42943f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42943f32",
  null
  
)

export default component.exports